if (!customElements.get('card-gallery')) {
  customElements.define(
    'card-gallery',
    class CardGallery extends HTMLElement {
      connectedCallback() {
        this._track = this.querySelector('.card-gallery__track');
        this._prevBtn = this.querySelector('.card-gallery__prev');
        this._nextBtn = this.querySelector('.card-gallery__next');

        if (!this._track) return;

        this._slides = this._track.querySelectorAll('.card-gallery__slide');
        this._count = this._slides.length;
        this._currentIndex = 0;

        if (this._count <= 1 || !this._prevBtn || !this._nextBtn) return;

        this._prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this._goTo(this._currentIndex <= 0 ? this._count - 1 : this._currentIndex - 1);
        });

        this._nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this._goTo(this._currentIndex >= this._count - 1 ? 0 : this._currentIndex + 1);
        });

        this._track.addEventListener(
          'scroll',
          () => {
            if (this._scrollTimer) clearTimeout(this._scrollTimer);
            this._scrollTimer = setTimeout(() => {
              const w = this._track.clientWidth;
              if (w > 0) this._currentIndex = Math.round(this._track.scrollLeft / w);
            }, 80);
          },
          { passive: true },
        );
      }

      _goTo(index) {
        this._currentIndex = index;
        this._track.scrollTo({ left: index * this._track.clientWidth, behavior: 'smooth' });
      }
    },
  );
}
